import { useState } from "react";
import { Dropdown } from "react-bootstrap";
import ThreeDotsIcon from "../../../icons/three-dots.icon";
import styles from "./index.module.scss";

const ContextMenu = ({ onEdit, onDelete }) => {
  const [isOpen, setIsOpen] = useState(false);

  const handleEdit = () => {
    setIsOpen(false);
    onEdit();
  };

  const handleDelete = () => {
    setIsOpen(false);
    onDelete();
  };

  return (
    <Dropdown 
      className={styles.contextMenuDropdown}
      show={isOpen}
      onToggle={(isOpen) => setIsOpen(isOpen)}
    >
      <Dropdown.Toggle 
        variant="link"
        className={styles.contextMenuToggle}
      >
        <div className={styles.contextMenuIcon}>
          <ThreeDotsIcon className={styles.icon16} />
        </div>
      </Dropdown.Toggle>

      <Dropdown.Menu className={styles.contextMenuMenu}>
        <Dropdown.Item
          onClick={handleEdit}
          className={styles.contextMenuItem}
        >
          <span className={styles.contextMenuButtonText}>Edit</span>
        </Dropdown.Item>
        <Dropdown.Item
          onClick={handleDelete}
          className={styles.contextMenuItem}
        >
          <span className={styles.contextMenuButtonTextDelete}>Delete</span>
        </Dropdown.Item>
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default ContextMenu;

